// Screen `signatures` (owner: doc-signing, owner feedback F5): the envelope list.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SIGNATURE_LIST_SCOPES } from '@dataroom/core/search-enums';
import { SignaturesPage } from '../../features/signatures/SignaturesPage';

export const Route = createFileRoute('/_app/signatures')({
  validateSearch: z.object({
    scope: z.enum(SIGNATURE_LIST_SCOPES).optional().catch(undefined),
    request: z.uuid().optional().catch(undefined),
    q: z.string().max(200).optional().catch(undefined),
  }),
  component: function SignaturesRoute() {
    return <SignaturesPage search={Route.useSearch()} />;
  },
});
